import ApiClient from './ApiClient';
import { AxiosInstance, AxiosResponse } from 'axios';
import { NewWebhook, WebhookResponse } from '../types/Webhook/Webhook';

export default class WebhookService extends ApiClient {
  private static get webhookClient(): AxiosInstance {
    return this.client;
  }

  public static async getTypesOfWebhooks(): Promise<string[]> {
    let res = await this.webhookClient.request<string[]>({
      method: 'GET',
      url: this.apiDomain + '/v1/webhook/available-events',
    });

    return res.data;
  }

  public static async getWebhooks(): Promise<WebhookResponse[]> {
    let res = await this.webhookClient.request<WebhookResponse[]>({
      method: 'GET',
      url: this.apiDomain + '/v1/webhook',
    });
    if (!!res.data) {
      return res.data;
    } else return [] as WebhookResponse[];
  }

  public static async createWebhook(newWebhook: NewWebhook): Promise<WebhookResponse> {
    return (
      await this.webhookClient.request<NewWebhook, AxiosResponse<WebhookResponse>>({
        method: 'POST',
        url: this.apiDomain + '/v1/webhook',
        data: newWebhook,
      })
    ).data;
  }

  public static async deleteWebhook(id: string): Promise<boolean> {
    let res = await this.webhookClient.request({
      method: 'DELETE',
      url: this.apiDomain + '/v1/webhook/' + id,
    });

    return res.status === 200;
  }

  public static async updateWebhook(id: string, webhook: NewWebhook): Promise<WebhookResponse> {
    return (
      await this.webhookClient.request<NewWebhook, AxiosResponse<WebhookResponse>>({
        method: 'PUT',
        url: this.apiDomain + '/v1/webhook/' + id,
        data: webhook,
      })
    ).data;
  }
}
